import labelsServiceApi from 'shared/api/labels.service.api';
import qualityMetricServiceApi from 'shared/api/quality-metric.service.api';

export const getLabels = async () => {
  const { data } = await labelsServiceApi.getLabels();

  const { labels } = data;

  if (!labels?.length) return [];

  return labels;
};

export const getMetrics = async () => {
  const { data } = await qualityMetricServiceApi.getOrganizationMetrics();

  const { qualityMetrics } = data;

  if (!qualityMetrics?.length) return [];

  return qualityMetrics;
};
